import { FormHelperText, InputLabel } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { SecondaryButton, TextBox } from '../../../../../Core/Controls';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Grid, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';
import {
    getPenaltyChargesNotes_Details,
    postPenaltyChargeNote_Delete,
    postPenaltyChargesNotes_AddUpdate
} from '../../../../../Core/Services/InternalUser/ControllerService/penaltyCharges-Service';
import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment';
import { useToast } from '../../../../../Core/Hooks/useToast';
import DeleteIcon from '@material-ui/icons/Delete';
import ConfirmationModal from '../../../../../Core/Modal/ConfirmationModal';
import DialogComp from '../../../../../Core/Dialog/DialogComp';

const StyledTableCell = withStyles(() => ({
    head: {
        fontSize: 16,
        padding: '8px 5px',
        color: '#f50057'
    },
    body: {
        fontSize: 14,
        padding: '8px 5px'
    }
}))(TableCell);

const StyledTableRow = withStyles(() => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const PenaltyChargesNotes = (props) => {
    const { showToastWarning, showToastError, showToastSuccess } = useToast();
    const [penaltyDetails, setPenaltyNotesDetails] = useState({
        penaltyChargeNoteDescription: '',
        penaltyChargeNoteID: '',
        penaltyChargeNotesList: [],
        selectedPenaltyNote: null
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showWarning, setShowWarning] = useState(false);

    const fetchPenaltyChargeNotes = async () => {
        let res = await getPenaltyChargesNotes_Details(props.chargeID);
        if (res.success) {
            setPenaltyNotesDetails((st) => ({
                ...st,
                penaltyChargeNotesList: res.data.list
            }));
        }
    };

    useEffect(() => {
        fetchPenaltyChargeNotes();
    }, [props.chargeID]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPenaltyNotesDetails((st) => ({
            ...st,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        let err = {};
        if (!penaltyDetails.penaltyChargeNoteDescription) {
            err.penaltyChargeNoteDescription = 'Description is required';
        }
        setErrors(err);
        if (Object.keys(err).length > 0) return;

        setLoading(true);
        const data = {
            penaltyChargeID: props.chargeID,
            penaltyChargeNoteID: penaltyDetails.penaltyChargeNoteID || null,
            penaltyChargeNoteDescription: penaltyDetails.penaltyChargeNoteDescription
        };
        let res = await postPenaltyChargesNotes_AddUpdate(data);
        if (res.success) {
            setPenaltyNotesDetails((st) => ({
                ...st,
                penaltyChargeNoteDescription: '',
                penaltyChargeNoteID: ''
            }));
            await fetchPenaltyChargeNotes();
        }
        setLoading(false);
    };

    const handleClear = () => {
        setPenaltyNotesDetails((st) => ({
            ...st,
            penaltyChargeNoteDescription: '',
            penaltyChargeNoteID: ''
        }));
        setErrors({});
    };

    const editHandle = (row) => {
        setPenaltyNotesDetails((st) => ({
            ...st,
            penaltyChargeNoteDescription: row.penaltyChargeNoteDescription,
            penaltyChargeNoteID: row.penaltyChargeNoteID
        }));
    };

    const handleDeletePenalty = async () => {
        let res = await postPenaltyChargeNote_Delete(penaltyDetails.selectedPenaltyNote.penaltyChargeNoteID);
        if (res.success) {
            showToastSuccess(res.message);
            handleModalClose(true);
            await fetchPenaltyChargeNotes();
        }
    };

    const deleteHandle = async (row) => {
        setShowWarning(true);
        setPenaltyNotesDetails((st) => ({
            ...st,
            selectedPenaltyNote: row
        }));
    };

    const handleModalClose = async (row) => {
        setShowWarning(false);
        setPenaltyNotesDetails((st) => ({
            ...st,
            selectedPenaltyNote: null
        }));
    };

    return (
        <Grid container spacing={2} className="custom-scroll">
            <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                    <Grid item xs={12} sm className="mandatory-fields">
                        <InputLabel shrink required>
                            New Note
                        </InputLabel>
                        <TextBox
                            name="penaltyChargeNoteDescription"
                            value={penaltyDetails.penaltyChargeNoteDescription}
                            onChange={handleChange}
                            required
                            autoFocus
                        />
                        <FormHelperText error>{errors.penaltyChargeNoteDescription}</FormHelperText>
                    </Grid>
                    <Grid item>
                        <Grid container spacing={1}>
                            <Grid item>
                                <SecondaryButton onClick={handleSubmit} isBtnLoader={loading}>
                                    {penaltyDetails.penaltyChargeNoteID ? 'Update' : 'Add'}
                                </SecondaryButton>
                            </Grid>
                            {penaltyDetails.penaltyChargeNoteID && (
                                <Grid item>
                                    <SecondaryButton onClick={handleClear}>Clear</SecondaryButton>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper} className="custom-scroll" style={{ minHeight: '400px' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell></StyledTableCell>
                                <StyledTableCell width="93%">Description</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {penaltyDetails.penaltyChargeNotesList.map((row, index) => (
                                <StyledTableRow key={row.penaltyChargeNoteID || index}>
                                    <StyledTableCell>
                                        <Grid container alignItems="center" justifyContent="space-around">
                                            <EditIcon fontSize="small" color="secondary" style={{ cursor: 'pointer' }} onClick={() => editHandle(row)} />
                                            <DeleteIcon fontSize="small" color="secondary" style={{ cursor: 'pointer' }} onClick={() => deleteHandle(row)} />
                                        </Grid>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <div>
                                            <div>{row.penaltyChargeNoteDescription}</div>
                                            <small style={{ float: 'right', fontSize: '12px', margin: 0, color: 'grey', fontStyle: 'italic' }}>
                                                {' '}
                                                {row.updatedby} @{moment(row.updated).format('MMM DD YYYY hh:mm A')}
                                            </small>
                                        </div>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            {showWarning ? (
                <DialogComp title={'Warning'} onClose={() => handleModalClose(false)} maxWidth="sm" fullWidth>
                    <ConfirmationModal
                        message={'Are you sure you want to delete this note'}
                        handleSubmit={handleDeletePenalty}
                        handleCancel={() => handleModalClose(false)}
                    />
                </DialogComp>
            ) : null}
        </Grid>
    );
};

export default PenaltyChargesNotes;
